/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Notifications_Task_Reopened_TitleInputs */

const en_notifications_task_reopened_title = /** @type {(inputs: Notifications_Task_Reopened_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} was reopened`)
};

const pt_br2_notifications_task_reopened_title = /** @type {(inputs: Notifications_Task_Reopened_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.task} foi reaberta`)
};

/**
* | output |
* | --- |
* | "{task} was reopened" |
*
* @param {Notifications_Task_Reopened_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_reopened_title = /** @type {((inputs: Notifications_Task_Reopened_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Reopened_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_reopened_title(inputs)
	return pt_br2_notifications_task_reopened_title(inputs)
});